import { GetSpaceBase } from '../../types/GetSpaceBase';
import { getUndefinedSpace } from '../../utils/getUndefinedSpace';
import { spaceFactory } from '../../utils/spaceFactory';
import { getPichinchaPaymentLink } from './getPichinchaPaymentLink';

// TODO: monkeypatch o algo que me permita agregar info al space para saber que vino de esta función
export const getSpacePichincha: GetSpaceBase = (group, space, context, extra) => {
  const { negBooleans } = context;
  const {
    isCreditCard,
    isCreditoSi,
    isPaymentPromise,
    isRefinance,
    isPichincha,
  } = negBooleans!;

  const { gT } = extra;

  const dynamicLink = getPichinchaPaymentLink({
    isPichincha,
    isPaymentPromise,
    isRefinance,
    isCreditCard,
    gT,
  });

  const extraContext = {
    paymentLinkPichincha: dynamicLink,
  };
  switch (group) {
    case 'NEG_OPTION_CONDITIONS': {
      switch (space) {
        case 'consequences.text': {
          if (isCreditoSi) {
            return spaceFactory('NEG_OPTION_CONDITIONS.consequences.text.CreditoSi').get(extraContext);
          } if (isCreditCard) {
            return spaceFactory('NEG_OPTION_CONDITIONS.consequences.text.CreditCard').get(extraContext);
          }
          return spaceFactory('NEG_OPTION_CONDITIONS.consequences.text').get(extraContext);

          break;
        }
        case 'confirmation.text': {
          if (isCreditCard || isCreditoSi) {
            return spaceFactory('NEG_OPTION_CONDITIONS.confirmation.text.CreditoSi').get(extraContext);
          }
          return spaceFactory('NEG_OPTION_CONDITIONS.confirmation.text').get(extraContext);

          break;
        }

        default: break;
      }
      break;
    }
    case 'NEG_CONFIRMATION': {
      switch (space) {
        case 'negotiation.text': {
          if (isCreditCard) {
            return spaceFactory('NEG_CONFIRMATION.negotiation.text.CreditCard').get(extraContext);
          }
          if (isCreditoSi) {
            return spaceFactory('NEG_CONFIRMATION.negotiation.text.CreditoSi').get(extraContext);
          }
          return spaceFactory('NEG_CONFIRMATION.negotiation.text').get(extraContext);

          break;
        }
        default: break;
      }
      break;
    }
    default: break;
  }

  return getUndefinedSpace();
};
